import { useTranslation } from 'react-i18next';

/**
 * Returns a function that picks the localized version of an object's translatable fields.
 * Usage:
 *   const localize = useLocalize();
 *   const localized = localize(destination, ['title','vibe','description']);
 *
 * Falls back to the source-language value if no translation exists for the current language.
 */
export function useLocalize() {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || i18n.language || 'en';

  return function localize(record, fields = []) {
    if (!record) return record;
    if (lang === 'en' || !record.translations || !record.translations[lang]) {
      return record;
    }
    const t = record.translations[lang];
    const out = { ...record };
    for (const f of fields) {
      if (t[f] !== undefined && t[f] !== null && t[f] !== '') out[f] = t[f];
    }
    return out;
  };
}

export default useLocalize;
